export default {
      id: "close-usage",
      viewBox: "0 0 42 42",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#close",
      toString: function () {
        return this.url;
      }
    }